import _objectSpread from "@babel/runtime/helpers/objectSpread";
var tcpyConfig = require('../../tcpy-conf.json').TTP;
var config = process.env.IDC_ENV !== 'TTP' ? {} : _objectSpread({}, tcpyConfig);
export default config;